import PropTypes from "prop-types"

import { cn } from "styles/utils"

import Image from "./image"

const Picture = ({ className, fallback, lazyload, srcSet, ...props }) => {
  return (
    <picture>
      {srcSet.map((src, i) => (
        <source
          height={src.height}
          key={`src-${i}`}
          media={src.media}
          sizes={src.sizes}
          type={src.type}
          width={src.width}
          {...(lazyload
            ? {
                "data-srcset": src.srcSet,
              }
            : {
                srcSet: src.srcSet,
              })}
        />
      ))}
      <Image
        className={cn("w-full", className)}
        lazyload={lazyload}
        src={fallback}
        {...props}
      />
    </picture>
  )
}

Picture.defaultProps = {
  lazyload: true,
}

Picture.propTypes = {
  className: PropTypes.string,
  fallback: PropTypes.string,
  lazyload: PropTypes.bool,
  srcSet: PropTypes.array,
}

Picture.displayName = "Picture"

export default Picture
